import { RefObject, useEffect } from "react";
import type { TableRef } from "antd/es/table";
import { useAppDispatch, useAppSelector } from "../../app";
import { changeScrollToEntity } from "../../app/store/appSlice";
import { GroupBlockTableData } from "../interfaces/groupBlockTable";

const useVirtualTableScroll = (
  tableRef: RefObject<TableRef | null>,
  data: Array<GroupBlockTableData> | undefined,
) => {
  const dispatch = useAppDispatch();
  const scrollIntoView = useAppSelector(
    (state) => state.appReducer.scrollIntoView,
  );

  useEffect(() => {
    if (scrollIntoView?.index && tableRef.current && data) {
      // Find the actual array index of the row with the target logical index
      // This accounts for page break rows that may shift positions
      const arrayIndex = data.findIndex(
        (row) => !row.isPageBreak && row.index === scrollIntoView.index,
      );

      if (arrayIndex !== -1) {
        tableRef.current.scrollTo({ index: arrayIndex });
      }
      dispatch(changeScrollToEntity(undefined));
    }
  }, [scrollIntoView, dispatch, tableRef, data]);
};

export default useVirtualTableScroll;
